import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicCISCRISC = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="CISC and RISC Architectures"
      videos={[ 
        "https://www.youtube.com/embed/bTCuFmY0sUg",
        "https://www.youtube.com/embed/3UddrvigqYk",
      ]}
      takeaways={[
        { text: "Directly remember the difference between CISC and RISC architectures." },
      ]}
      questions={[]} // Add questions if needed
      exampleVideos={[]} // Add example question videos if needed
    />
);
}

export default ModuleSubtopicCISCRISC;
